const isProduction = process.env.NODE_ENV === "production";

const getBasePath = () => {
  return isProduction
    ? process.env.REACT_APP_ASSETS_URL
    : process.env.REACT_APP_API_BASE_URL;
};
export { getBasePath };